module.exports = __webpack_public_path__ + "img/NCaravan64_ua.56ec8cdc.webp";